<template>
    <section>
        <b-modal v-model="open" :title="$t('message.edit_organization')" ref="modal" id="modal-organization-edit">
            <vue-form-generator ref="organizationEdit" :schema="schema" :model="model" :options="formOptions" @validated="onValidated"></vue-form-generator>
            <template #footer>
                <b-btn @click="open=false">{{$t('message.cancel')}}</b-btn>
                <b-btn @click="validate" type="primary">{{$t('message.save')}}</b-btn>
            </template>
        </b-modal>
    </section>
</template>

<script>
    import VueFormGenerator from 'vue-form-generator'
    import mixins from '../../../modules/mixins'
    import {ORGANIZATION_REQUEST, TIMEZONE_REQUEST} from '../../../_store'
    import eventBus from '../../../modules/eventBus'
    import cc from 'currency-codes'

    export default {
        name: 'edit-organization',
        mixins: [mixins],
        data () {
            return {
                open: false,
                isValid: false,
                item: false,
                model: {
                    id: null,
                    name: null,
                    street: '',
                    houseNumber: '',
                    city: '',
                    zip: '',
                    country: '',
                    identificationNumber: '',
                    pricePerLiterCold: 'false-0.1',
                    pricePerLiterHot: 'false-0.1',
                    pricePerPower: 'false-4.5',
                    pricePerUnit: 'false-1',
                    timezone: 'Europe/Prague',
                    currency: 'CZK'
                },
                schema: {
                    fields: [{
                        type: 'input',
                        inputType: 'hidden',
                        model: 'id'
                    }, {
                        type: 'input',
                        inputType: 'text',
                        i18n: {
                            label: 'message.name'
                        },
                        model: 'name'
                    }, {
                        type: 'input',
                        inputType: 'text',
                        i18n: {
                            label: 'message.street'
                        },
                        model: 'street'
                    }, {
                        type: 'input',
                        inputType: 'text',
                        i18n: {
                            label: 'message.house_number'
                        },
                        model: 'houseNumber'
                    }, {
                        type: 'input',
                        inputType: 'text',
                        i18n: {
                            label: 'message.city'
                        },
                        model: 'city'
                    }, {
                        type: 'input',
                        inputType: 'text',
                        i18n: {
                            label: 'message.zip'
                        },
                        model: 'zip'
                    }, {
                        type: 'input',
                        inputType: 'text',
                        i18n: {
                            label: 'message.country'
                        },
                        model: 'country'
                    }, {
                        type: 'input',
                        inputType: 'text',
                        i18n: {
                            label: 'message.company_id'
                        },
                        model: 'identificationNumber'
                    }, {
                        type: 'select',
                        i18n: {
                            label: 'message.timezone'
                        },
                        model: 'timezone',
                        values: [],
                        selectOptions: {
                            hideNoneSelectedText: true
                        }
                    }, {
                        type: 'select',
                        i18n: {
                            label: 'message.currency'
                        },
                        model: 'currency',
                        values: cc.codes(),
                        selectOptions: {
                            hideNoneSelectedText: true
                        }
                    }, {
                        type: 'checkboxText',
                        i18n: {
                            label: 'message.price_estimate_cold_water',
                            checkboxLabel: 'message.from_parent_object',
                            unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.liter')
                        },
                        disableCheckbox: true,
                        model: 'pricePerLiterCold',
                        pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                        validator: [VueFormGenerator.validators.regexp]
                    },
                    {
                        type: 'checkboxText',
                        i18n: {
                            label: 'message.price_estimate_hot_water',
                            checkboxLabel: 'message.from_parent_object',
                            unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.liter')
                        },
                        model: 'pricePerLiterHot',
                        disableCheckbox: true,
                        pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                        validator: [VueFormGenerator.validators.regexp]
                    },
                    {
                        type: 'checkboxText',
                        i18n: {
                            label: 'message.price_estimate_power',
                            checkboxLabel: 'message.from_parent_object',
                            unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.power')
                        },
                        model: 'pricePerPower',
                        disableCheckbox: true,
                        pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                        validator: [VueFormGenerator.validators.regexp]
                    },
                    {
                        type: 'checkboxText',
                        i18n: {
                            label: 'message.price_estimate_heat',
                            checkboxLabel: 'message.from_parent_object',
                            unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.heat_units')
                        },
                        model: 'pricePerUnit',
                        disableCheckbox: true,
                        pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                        validator: [VueFormGenerator.validators.regexp]
                    }
                    ]
                },
                formOptions: {
                    validateAfterLoad: false,
                    validateAfterChanged: true
                }
            }
        },
        methods: {
            onValidated  (isValid) {
                this.isValid = isValid
            },
            validate () {
                this.$refs.organizationEdit.validate()
                if (this.isValid) {
                    let changedCurrency = this.activeOrganization.currency !== this.model.currency
                    this.model.action = 'update'
                    this.$store.dispatch(ORGANIZATION_REQUEST, this.model).then(response => {
                        if (response.data.result) {
                            this.open = false
                            eventBus.emit('change', {force: true, source: 'edit-org'})
                            if (changedCurrency) {
                                eventBus.emit('language')
                            }
                        } else {
                            this.notify('info', response.data.message)
                        }
                    })
                    this.open = false
                }
            },
            show (item) {
                this.item = item
                this.$store.dispatch(ORGANIZATION_REQUEST, {action: 'read', id: item.id})
                    .then(response => {
                        this.model = response.data.data
                    })
                this.open = true
            }
        },
        created () {
            this.$store.dispatch(TIMEZONE_REQUEST)
                .then(resp => {
                    this.schema.fields[8].values = resp.data.timezones
                })
        }
    }
</script>

<style scoped>

</style>
